import React, { useState } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import "./PasswordField.css";

// Password <input> with an eye button to show/hide the value.
// Takes the same props as <input>; `block` makes the wrapper full width
// (use it where the input is width: 100%).
const PasswordField = React.forwardRef(function PasswordField(
  { block = false, ...inputProps },
  ref,
) {
  const [show, setShow] = useState(false);
  return (
    <span className={`password-field${block ? " is-block" : ""}`}>
      <input {...inputProps} ref={ref} type={show ? "text" : "password"} />
      <button
        type="button"
        className="password-field-toggle"
        onClick={() => setShow((v) => !v)}
        aria-label={show ? "Hide password" : "Show password"}
        title={show ? "Hide password" : "Show password"}
      >
        {show ? (
          <VisibilityOffOutlinedIcon fontSize="small" />
        ) : (
          <VisibilityOutlinedIcon fontSize="small" />
        )}
      </button>
    </span>
  );
});

export default PasswordField;
